module.exports = __webpack_public_path__ + "img/banks.c8ee55f3.png";